import { theme, themeCss } from '#styles/themes'

import { anthracite, black, blue, green, red, silver, white, yellow } from './colors'
import { fontSizeAtomics, fontStretchAtomics, fontStyleAtomics, fontWeightAtomics } from './fonts'
import { quirks } from './quirks'
import { textStyleFragments } from './texts'
import { notCss } from './util'

/**
 * Style constants to be referenced directly in code
 * @example
 *   const myStyleClass = css`
 *     font-size: ${style.fontSize.s};
 *     line-height: ${style.lineHeight.s};
 *     background: ${style.colors.anthracite.primary};
 *   `
 */
export const style = {
  theme,
  themeCss,
  colors: notCss({
    anthracite: anthracite,
    red: red,
    silver: silver,
    blue: blue,
    green: green,
    yellow: yellow,
    white: white,
    black: black,
  } as const),
  constants: notCss({
    headerHeight: ' 56px ',
    headerHeightVariable: ` var(--header-height, 56px) `,
  } as const),
} as const

/**
 * Class atomics to be used in cx
 * @example
 *   <div className={cx(myStyle, classAtomics.text.s)}
 */
export const atomics = notCss({
  fontSize: fontSizeAtomics,
  fontStretch: fontStretchAtomics,
  fontWeight: fontWeightAtomics,
  fontStyle: fontStyleAtomics,
} as const)

export const fragments = notCss({
  textStyle: textStyleFragments,
  quirks: quirks,
} as const)
